import { render, staticRenderFns } from "./formKeywordDialog.vue?vue&type=template&id=1cdb8055&scoped=true"
import script from "./formKeywordDialog.vue?vue&type=script&lang=js"
export * from "./formKeywordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb8055",
  null
  
)

export default component.exports